<template>
    <v-expand-transition>
        <v-card v-show="showArea" elevation="0" outlined class="rounded-0">
            <v-card-title>
                분야선택
                <v-spacer />
                <v-icon @click="$emit('close')">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col v-for="parent in areas_structured" :key="parent._id" cols="6" lg="">
                        <v-row>
                            <v-col class="text-h6">{{ parent.name }}</v-col>
                        </v-row>
                        <v-row v-for="(child, i) in parent.children" :key="i">
                            <v-col>
                                <template v-if="child.name !== etcAreaName">
                                    <v-checkbox v-model="filter._areas" :value="child._id" @change="input" hide-details multiple dense class="my-0 py-0">
                                        <template v-slot:label>
                                            {{ child.name }}
                                            <span class="ml-1" style="color:red">({{ child._experts.length }})</span>
                                        </template>
                                    </v-checkbox>
                                </template>
                                <template v-else>
                                    <filter-areas-manual v-model="filter.areas_manual" :children="child.children" @input="input" />
                                </template>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-expand-transition>
</template>

<script>
import FilterAreasManual from "./filter-areas-manual.vue";
const initialFilter = {
    _areas: [],
    areas_manual: [],
};
const etcAreaName = "기타(입력)";
export default {
    components: { FilterAreasManual },
    props: {
        value: {
            _areas: Array,
            areas_manual: Array,
        },
        areas: Array,
        areas_manual: Array,
        showArea: { type: Boolean, default: false },
    },
    computed: {
        areas_structured() {
            const parents = (this.areas || []).filter(({ _parent }) => !_parent).sort((a, b) => a.order - b.order);
            const areas = parents.map((parent) => ({
                ...parent,
                children: (this.areas || [])
                    .filter(({ _parent }) => _parent == parent._id)
                    .map((child) => (child.name == etcAreaName ? { ...child, children: (this.areas_manual || []).filter(({ _parent }) => _parent == parent._id) } : child))
                    .sort((a, b) => a.order - b.order),
            }));
            return areas;
        },
    },
    data() {
        return {
            etcAreaName,
            filter: { ...initialFilter },
        };
    },
    methods: {
        init() {
            this.filter = { ...initialFilter, ...this.value };
        },
        input() {
            this.$emit("input", { ...this.value, ...this.filter });
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        "value._areas"() {
            if (this.value?._areas?.some((_area) => !this.filter?._areas?.includes(_area))) this.init();
        },
        "value.areas_manual"() {
            if (this.value?.areas_manual?.some(({ _parent, name }) => !this.filter?.areas_manual?.find((manual) => manual._parent == _parent && manual.name == name))) this.init();
        },
    },
};
</script>
